import { DEFAULT_LOCALE } from '@constants'
import { ILocales } from 'constants/locales'

const getLocalesDropdownOptions = (pathname: string, locale: string, locales: ILocales, pageLocales?: string[]) => {
  let parsedPathName = pathname.replace('/page', '')
  let filteredLocales = locales
  const sortedPageLocales: string[] = []

  if (pageLocales && Array.isArray(pageLocales) && pageLocales.length !== 0) {
    locales.forEach(locale => {
      if (pageLocales.includes(locale.code)) sortedPageLocales.push(locale.code)
    })
    filteredLocales = sortedPageLocales.map(l => locales.find(local => local.code === l) || locales[0])
  }

  if (parsedPathName !== '/')
    parsedPathName =
      locale === DEFAULT_LOCALE
        ? parsedPathName
        : `/${parsedPathName
            .split('/')
            .filter(p => p !== '')
            .splice(1)
            .join('/')}`

  return filteredLocales.map(({ name, code }) => {
    const url = code === DEFAULT_LOCALE ? parsedPathName : `/${code}${parsedPathName}`
    return { name, url }
  })
}

export default getLocalesDropdownOptions
